import "./_snowpack/pkg/core-js/es/string/repeat.js";
import "./_snowpack/pkg/core-js/es/array/from.js";
import "./_snowpack/pkg/core-js/es/array/find.js";
import "./_snowpack/pkg/raf/polyfill.js";
import React from "./_snowpack/pkg/react.js";
import {createRoot} from "./_snowpack/pkg/react-dom/client.js";
import _LinesEllipsis from "./src/index.js";
import _HTMLEllipsis from "./src/html.js";
import responsiveHOC from "./src/responsiveHOC.js";
import lorem from "./lorem.js";
const LinesEllipsis = responsiveHOC()(_LinesEllipsis);
const HTMLEllipsis = responsiveHOC()(_HTMLEllipsis);
const log = console.log.bind(console);
const lang = window.location.search.slice(1);
const defaultText = lorem[lang] || lorem.en;
const defaultMaxLine = 3;
const unsafe = lang === "html";
if (unsafe) {
  document.querySelector(".unsafe-warning").removeAttribute("hidden");
}
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: defaultText,
      maxLine: defaultMaxLine,
      useEllipsis: true
    };
    this.handleTextClick = this.handleTextClick.bind(this);
    this.handleTextKey = this.handleTextKey.bind(this);
    this.handleTextEdit = this.handleTextEdit.bind(this);
    this.handleChangeLines = this.handleChangeLines.bind(this);
  }
  componentDidMount() {
    log(`isClamped: ${this.linesEllipsis.isClamped()} when page didMount`);
  }
  handleTextClick(e) {
    e.preventDefault();
    this.setState({useEllipsis: false});
  }
  handleTextKey(e) {
    if (e.keyCode === 13) {
      this.handleTextClick(e);
    }
  }
  handleTextEdit(e) {
    this.setState({
      text: e.target.value,
      useEllipsis: true
    });
  }
  handleChangeLines(e) {
    this.setState({
      maxLine: e.target.value,
      useEllipsis: true
    });
  }
  renderUnsafe() {
    const {text, maxLine, useEllipsis} = this.state;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", {
      className: "lines-controller hide-sm"
    }, "Show ", maxLine, " lines:", /* @__PURE__ */ React.createElement("input", {
      type: "range",
      defaultValue: defaultMaxLine,
      min: "1",
      max: "10",
      onChange: this.handleChangeLines
    })), useEllipsis ? /* @__PURE__ */ React.createElement("div", {
      onClick: this.handleTextClick,
      onKeyDown: this.handleTextKey,
      tabIndex: "0"
    }, /* @__PURE__ */ React.createElement(HTMLEllipsis, {
      innerRef: (node) => {
        this.linesEllipsis = node;
      },
      component: "article",
      className: "ellipsis-html",
      unsafeHTML: text,
      maxLine,
      ellipsisHTML: "<i>... read more</i>",
      onReflow: log
    })) : /* @__PURE__ */ React.createElement("article", {
      className: "ellipsis-html",
      dangerouslySetInnerHTML: {__html: text}
    }), /* @__PURE__ */ React.createElement("textarea", {
      className: "text-editor",
      defaultValue: defaultText,
      onChange: this.handleTextEdit,
      placeholder: "Enter any HTML",
      spellCheck: "false"
    }));
  }
  renderSafe() {
    const {text, maxLine, useEllipsis} = this.state;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("label", {
      className: "lines-controller hide-sm"
    }, "Show ", maxLine, " lines:", /* @__PURE__ */ React.createElement("input", {
      type: "range",
      defaultValue: defaultMaxLine,
      min: "1",
      max: "10",
      onChange: this.handleChangeLines
    })), useEllipsis ? /* @__PURE__ */ React.createElement("div", {
      onClick: this.handleTextClick,
      onKeyDown: this.handleTextKey,
      tabIndex: "0"
    }, /* @__PURE__ */ React.createElement(LinesEllipsis, {
      innerRef: (node) => {
        this.linesEllipsis = node;
      },
      component: "article",
      className: "ellipsis-text",
      text,
      maxLine,
      ellipsis: "... read more",
      onReflow: log
    })) : /* @__PURE__ */ React.createElement("article", {
      className: "ellipsis-text"
    }, text), /* @__PURE__ */ React.createElement("textarea", {
      className: "text-editor",
      defaultValue: defaultText,
      onChange: this.handleTextEdit,
      placeholder: "Enter any text",
      spellCheck: "false"
    }));
  }
  render() {
    return unsafe ? this.renderUnsafe() : this.renderSafe();
  }
}
window.requestAnimationFrame(function bootstrap() {
  console.debug(`React version ${React.version}`);
  createRoot(document.getElementById("react-root")).render(/* @__PURE__ */ React.createElement(React.StrictMode, null, /* @__PURE__ */ React.createElement(App, null)));
});
